import { createContext } from 'react';

interface MenuContext {
    active: string | null;
    expanded: string[];
}

const defaultValues: MenuContext = {
    active: null,
    expanded: []
};

const menuContext = createContext(defaultValues);

export default menuContext;
